import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppService } from 'src/app/core/services/app.service';
import { UserService } from 'src/app/core/services/user.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { CCProcessors } from 'src/app/shared/models/enums/CCProcessors.enum';
import { UserRoleEnum } from 'src/app/shared/models/enums/user-role.enum';
import { License } from 'src/app/shared/models/license.model';

@Component({
	selector: 'app-on-device-list',
	templateUrl: './on-device-list.component.html',
	styleUrls: ['../../../../commandcenter.scss'],
})
export class OnDeviceListComponent implements OnInit {
	@Input() licenseList: License[];
	@Output() licenseListChange = new EventEmitter<License[]>();

	@Input() onDeviceSelected: License;
	@Output() onDeviceSelectedChange = new EventEmitter<License>();
	constructor(public app: AppService, private userService: UserService, private venueService: OOVenueService) {}

	ngOnInit(): void {
		if (
			this.userService.userSubscription.value.role === UserRoleEnum.SUPERADMIN &&
			this.venueService.subscriptionVenue.value.ccProcessor === CCProcessors.FOCUSPAYDATACAP &&
			this.venueService.subscriptionVenue.value.dealerKey in ['XS7KOjiJ30i5gGQJuf_D9Q', 'V3w5b8sWhUKIk3ARrpxRZg']
		) {
			this.licenseList = [];
		}
	}
}
